let seo = require('../../../actions/seo');
let cookie = require('../../../actions/cookie');
let utils = require('../../../actions/utils');
let page = require('../../../actions/page');
let content = require('../../../actions/layout/content');
let price = require('../../../actions/order/price');
let layoutGroup = require('../../groups/layout');
let analytics = require('../../../actions/analytics');
let pricesGroup = require('../../groups/prices');

module.exports = [
    page.cleanup(),
    analytics.parseUtmFromQuery,
    utils.set('layout', 'order'),
    utils.set(['bitrix', 'isBitrix'], true),
    utils.setFromArgsToState('bitrixDomain', ['bitrix', 'domain']),
    [
        utils.isEqual(['user', 'role'], undefined),
        {
            yes: [
                utils.set(['user', 'role'], 'unauthorized')
            ],
            no: []
        }
    ],
    // провемя, что cookies соответствуют текущему домену Битрикс
    // если нет, то чистим их, потом обновим
    [
        utils.isArgNotNull('bitrixDomain'),
        {
            yes: [
                cookie.getArgFromCookie('bitrixDomainCookie', 'bitrix_domain'),
                [
                    utils.isArgsEqual('bitrixDomainCookie', 'bitrixDomain'),
                    {
                        yes: [],
                        no: [
                            cookie.unsetCookie({ key: 'bitrix_access_token' }),
                            cookie.unsetCookie({ key: 'bitrix_domain' }),
                            cookie.unsetCookie({ key: 'bitrix_member_id' })
                        ]
                    }
                ]
            ],
            no: []
        }
    ],
    ...layoutGroup.setMainLayoutBlocks,
    seo.setDashboardMeta('Данные об организациях: база телефонов, email адресов организаций - Библиотека данных',
        'Официальная библиотека данных 2ГИС: актуальные номера телефонов, email адреса фирм и организаций.'),
    content.setComponentsByLink,
    utils.setPopupVisibility('datepicker', ['order', 'popups', 'datepicker', 'isOpen']),
    utils.setPopupVisibility('datepicker2', ['order', 'popups', 'datepicker2', 'isOpen']),
    price.setIsLoading(true),
    content.setIsLoading(true),
    analytics.pageview,
    pricesGroup.getPrices,
    ...pricesGroup.setComputedFields
];



// WEBPACK FOOTER //
// ./signals/pages/bitrixMain/index.js